import { useQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import { listFilestoreRepos } from '@/services/filestore/list-repos';
import type { FilestoreReposResponse } from '@/types/filestore';

export const FILESTORE_QUERY_KEY = 'filestore';

export const useFilestoreRepos = () => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<FilestoreReposResponse, Error>({
    queryKey: [FILESTORE_QUERY_KEY, orgId, 'repos'],
    queryFn: () => listFilestoreRepos(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
    retry: 1,
  });
};
